import { ENDPOINTS } from 'features/daily-plan/constants';
import { CONTACT_TAB_IDS } from 'features/inventory-profiles/constants';
import { SECONDARY_API_CLIENT } from 'services/API';
import { ProfileTablesPreferenceKeys } from 'UI/components/organisms/inventoryProfiles/tabKeys';
import {
  formatTasksResponse,
  TASK_COLUMNS,
  TASKS_EXTRA_RENDERERS
} from 'UI/components/organisms/inventoryProfiles/TasksTab';
import { Endpoints } from 'UI/constants/endpoints';
import { ENTITY_TYPE_ID_MAP, EntityType } from 'UI/constants/entityTypes';

import { formatDatasheetResponse } from './ContactProfileV2.utils';

export const CONTACT_TABS_CONFIG = {
  [CONTACT_TAB_IDS.ActionPlan]: {
    DataTableProps: {
      apiVersion: 1,
      endpoint: ENDPOINTS.tasks,
      formatResponse: formatTasksResponse
    },
    entityType: EntityType.Contact,
    entityTypeId: ENTITY_TYPE_ID_MAP.contact,
    extraRenderers: TASKS_EXTRA_RENDERERS,
    initialColumns: TASK_COLUMNS,
    tablePreferencesKey: ProfileTablesPreferenceKeys.ContactsTasks
  },
  [CONTACT_TAB_IDS.DataSheet]: {
    apiInstance: SECONDARY_API_CLIENT,
    endpoint: Endpoints.ContactDataSheetById,
    entityType: EntityType.Contact,
    formatResponse: formatDatasheetResponse
  }
};
